import React, { useState } from 'react';
import { Checkbox, Typography } from 'fronton-react';
import { ChooseKeycardWrapper, LinkButton, MarketingConsentCheckboxWrapper } from './styles';
import { Keycard } from './keycard';
import { EKeycardType } from 'reducers/loyalty-registration-modal-reducer';
import { sendChooseCardEvent, sendGetPromoCheckboxEvent } from 'utils/ga-events';
import { Trans, useTranslation } from 'react-i18next';

export interface IChooseKeycardProps {
  fetchPhoneVerify: (keycardType: EKeycardType, marketingConsent: boolean) => void;
  setKeycardTypeAndMarketingConsent: (keycardType: EKeycardType, marketingConsent: boolean) => void;
}

export const ChooseKeycard: React.FC<IChooseKeycardProps> = ({
  fetchPhoneVerify,
  setKeycardTypeAndMarketingConsent,
}) => {
  const { t } = useTranslation();
  const [marketingConsent, setMarketingContest] = useState<boolean>(true);

  const handleChange = (keycardType: EKeycardType) => {
    setKeycardTypeAndMarketingConsent(keycardType, marketingConsent);
    fetchPhoneVerify(keycardType, marketingConsent);
    sendChooseCardEvent(keycardType);
  };

  const handleCheckbox = (value: boolean) => {
    setMarketingContest(value);
    sendGetPromoCheckboxEvent();
  };

  return (
    <>
      <ChooseKeycardWrapper>
        <Keycard
          title={t('loyalty-registration-modal.choose-keycard-step.keycard-home')}
          label={t('loyalty-registration-modal.choose-keycard-step.for-repair')}
          onCreate={() => handleChange(EKeycardType.HOME)}
        />
        <Keycard
          title={t('loyalty-registration-modal.choose-keycard-step.keycard-pro')}
          label={t('loyalty-registration-modal.choose-keycard-step.for-builders')}
          pro
          onCreate={() => handleChange(EKeycardType.PRO)}
        />
      </ChooseKeycardWrapper>
      <Typography variant="s" size="body_short" color="text-secondary">
        <Trans
          i18nKey="loyalty-registration-modal.choose-keycard-step.agreements"
          components={{
            KeycardHomeLink: (
              <LinkButton
                as="a"
                target="_blank"
                href="https://storage.yandexcloud.net/lmru-loyalty-documents/ru/keycard-for-home-rules.pdf"
              />
            ),
            KeycardProLink: (
              <LinkButton
                as="a"
                target="_blank"
                href="https://storage.yandexcloud.net/lmru-loyalty-documents/ru/keycard-pro-rules.pdf"
              />
            ),
          }}
        />
      </Typography>
      <MarketingConsentCheckboxWrapper>
        <Checkbox
          data-qa="marketing-consent"
          color="text-secondary"
          checked={marketingConsent}
          onChange={handleCheckbox}
          label={t('loyalty-registration-modal.choose-keycard-step.want-reveice-promo')}
          withExtraClickZone={false}
        />
      </MarketingConsentCheckboxWrapper>
    </>
  );
};
